import React from 'react';
import { States } from '../Constants';
import SelectInput from './SelectInput';

const StateSelectInput = props => {
    const options = States.map(so => so.Name);
    const values = States.map(so => so.Value);

    const myDef = { ...props.def, options, values };
    const myProps = { ...props, name: 'stateinput_de' };

    return <SelectInput {...myProps} def={myDef} />
}

export default StateSelectInput;
